import PurchaseScreenContent from './PurchaseScreenContent';

export default PurchaseScreenContent;
